/**
 * Étapes du tour d'accueil, communes à tous les espaces : celles qui visent une entrée de
 * menu absente du rôle courant sont écartées par le moteur.
 */
import i18n from "../../../i18n/i18n";
import { Space } from "../../../utils/roles";
import { anchoredStep, compactSteps, TourStep } from "../tourEngine";

/** L'installateur voit aussi les produits que ses clients lui partagent. */
const devicesText = (space: Space): string =>
  space === "breeder"
    ? i18n.t("tour-welcome-devices-text-breeder")
    : i18n.t("tour-welcome-devices-text-installer");

export const welcomeTourSteps = (space: Space) => (): TourStep[] =>
  compactSteps([
    {
      popover: {
        title: i18n.t("tour-welcome-title"),
        description: i18n.t("tour-welcome-text"),
      },
    },
    anchoredStep(["#tour-nav"], {
      popover: {
        title: i18n.t("tour-welcome-nav-title"),
        description: i18n.t("tour-welcome-nav-text"),
      },
    }),
    anchoredStep(["#tour-nav-section_dashboard"], {
      popover: {
        title: i18n.t("tour-welcome-dashboard-title"),
        description: i18n.t("tour-welcome-dashboard-text"),
      },
    }),
    // Éleveur : « Régulateurs » remplace la liste des produits dans son menu.
    anchoredStep(
      ["#tour-nav-section_devices", "#tour-nav-section_regulators"],
      {
        popover: {
          title: i18n.t("tour-welcome-devices-title"),
          description: devicesText(space),
        },
      }
    ),
    anchoredStep(["#tour-nav-section_breedings"], {
      popover: {
        title: i18n.t("tour-welcome-breedings-title"),
        description: i18n.t("tour-welcome-breedings-text"),
      },
    }),
    anchoredStep(["#tour-nav-section_partnerships"], {
      popover: {
        title: i18n.t("tour-welcome-partnerships-title"),
        description: i18n.t("tour-welcome-partnerships-text"),
      },
    }),
    // Mobile : le bloc profil est dans le tiroir fermé, on montre le « … » qui l'ouvre.
    anchoredStep(["#tour-nav-profile", "#tour-nav-more"], {
      popover: {
        title: i18n.t("tour-welcome-profile-title"),
        description: i18n.t("tour-welcome-profile-text"),
      },
    }),
    {
      popover: {
        title: i18n.t("tour-welcome-end-title"),
        description: i18n.t("tour-welcome-end-text"),
      },
    },
  ]);
